export default {
  meta: {
    title: '公司管理',
    url: '/organization/branchcompany' // 埋点用，记录所属模块
  },
};
